import { resolveCheckoutBrand } from "./checkoutBrand";

// Utility to load Razorpay script dynamically
export const loadScript = () => {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Razorpay script"));
    document.body.appendChild(script);
  });
};

export function openRazorpayCheckout({
  key,
  amount,
  currency = "INR",
  name,
  image,
  description,
  orderId,
  subscriptionId,
  handler,
  onDismiss,
  themeColor = "#16A34A",
}) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const brand = resolveCheckoutBrand();
  const displayName = name || brand.name;
  const displayImage = image || brand.image;
  const options = {
    key,
    amount,
    currency,
    description,
    handler,
    prefill: { name: user.name || "", email: user.email || "" },
    theme: { color: themeColor },
    modal: { ondismiss: onDismiss || (() => {}) },
  };
  if (displayName) options.name = displayName;
  if (displayImage) options.image = displayImage;
  if (subscriptionId) options.subscription_id = subscriptionId;
  if (orderId) options.order_id = orderId;
  const rzp = new window.Razorpay(options);
  rzp.open();
  return rzp;
}
